import {match, Pattern} from 'ts-pattern';

import {type Nullish, parseDate} from 'shared/web';

let serverClockOffsetMilliseconds: number | Nullish;

export const synchronizeTeasServerClock = (response: Response | undefined) =>
  match(response?.headers.get('date'))
    .with(Pattern.string, (serverDate) => {
      const serverTime = Date.parse(serverDate); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

      return match(Number.isFinite(serverTime))
        .with(true, () => {
          serverClockOffsetMilliseconds = serverTime - Date.now();
        })
        .with(false, () => undefined)
        .exhaustive();
    })
    .otherwise(() => undefined);

export const getTeasServerNow = () =>
  match(serverClockOffsetMilliseconds)
    .with(Pattern.number, (offsetMilliseconds) =>
      parseDate(Date.now() + offsetMilliseconds).toISOString()
    )
    .otherwise(() => undefined);
